@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.add-order-to-batch-or-print-container {
  display: flex;
  align-items: center;
}

.print-from-drawer {
  button {
    margin: -6px 0;
    border: 0;
    background: transparent;
    text-decoration: none;
    color: @orders-drawer--print-button--text-color !important;
    position: relative;
    cursor: pointer;
    font-size: 14px;

    &:hover,
    &.button:focus:hover {
      background: none;
      border: none;
      box-shadow: none !important;
    }

    svg {
      fill: @orders-drawer--print-button--text-color;
    }
  }
}
